module.exports = __webpack_public_path__ + "static/media/hp-catalog-hz-lg.4804d0f3.jpeg";